/**
 * personalizacao-camiseta.js
 * Controls the show/hide of Name + Number customization fields
 * Works with both PT (Personalizar/Não Personalizar) and EN (Customize/Don't Customize)
 */
(function() {
  'use strict';

  // Values that mean "YES, customize" (add both languages)
  const CUSTOMIZE_VALUES = [
    'customize', 'personalizar', 'sim', 'yes', 'add', 'adicionar'
  ];

  // Values that mean "NO, don't customize"  
  const NO_CUSTOMIZE_VALUES = [
    "don't customize", 'dont customize', 'não personalizar', 'nao personalizar',
    'não', 'nao', 'no', "don't", 'dont', 'no add', 'não adicionar'
  ];

  // Option names that indicate personalization
  const PERSONALIZACAO_KEYWORDS = [
    'personaliz', 'customize', 'custom', 'personali'
  ];

  function init() {
    // Find all product info sections
    const sections = document.querySelectorAll('product-info, [id^="ProductInfo-"]');
    
    sections.forEach(section => {
      const sectionId = section.id?.replace('ProductInfo-', '') || 
                        section.dataset?.section || '';
      setupPersonalizacao(section, sectionId);
    });

    // Also listen for variant changes via MutationObserver for dynamic updates
    observeVariantChanges();
  }

  function setupPersonalizacao(section, sectionId) {
    const container = document.getElementById('personalizacao-container-' + sectionId);
    if (!container) return;

    // Find the personalization option fieldset
    const fieldsets = section.querySelectorAll('fieldset, .product-form__input');
    
    fieldsets.forEach(fieldset => {
      const legend = fieldset.querySelector('legend, .form__label, label');
      if (!legend) return;
      
      const legendText = legend.textContent.toLowerCase().trim();
      const isPersonalizacao = PERSONALIZACAO_KEYWORDS.some(kw => legendText.includes(kw));
      
      if (!isPersonalizacao) return;

      // Found the personalization option - listen to its inputs
      const inputs = fieldset.querySelectorAll('input[type="radio"], input[type="hidden"], select');
      
      inputs.forEach(input => {
        if (input.type === 'radio') {
          input.addEventListener('change', () => {
            handleOptionChange(input.value, container, sectionId);
          });
          // Check initial state
          if (input.checked) {
            handleOptionChange(input.value, container, sectionId);
          }
        } else if (input.tagName === 'SELECT') {
          input.addEventListener('change', () => {
            handleOptionChange(input.value, container, sectionId);
          });
          handleOptionChange(input.value, container, sectionId);
        }
      });

      // Also listen for clicks on variant buttons (Dawn theme pattern)
      const buttons = fieldset.querySelectorAll('.product-form__input label, [data-option-value]');
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          setTimeout(() => {
            const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
            if (checkedInput) {
              handleOptionChange(checkedInput.value, container, sectionId);
            }
          }, 50);
        });
      });
    });

    // Setup number field validation
    const numInput = document.getElementById('personalizacao-numero-' + sectionId);
    if (numInput) {
      numInput.addEventListener('input', function() {
        this.value = this.value.replace(/[^0-9]/g, '').slice(0, 3);
      });
    }

    // Setup name field - uppercase and limit
    const nameInput = document.getElementById('personalizacao-nome-' + sectionId);
    if (nameInput) {
      nameInput.addEventListener('input', function() {
        if (this.value.length > 20) {
          this.value = this.value.slice(0, 20);
        }
      });
    }
  }

  function handleOptionChange(value, container, sectionId) {
    const val = value.toLowerCase().trim();
    
    const isCustomize = CUSTOMIZE_VALUES.some(cv => val === cv || val.includes(cv));
    const isNoCustomize = NO_CUSTOMIZE_VALUES.some(nv => val === nv || val.includes(nv));
    
    if (isCustomize && !isNoCustomize) {
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
      // Clear fields when hiding
      const nameInput = document.getElementById('personalizacao-nome-' + sectionId);
      const numInput = document.getElementById('personalizacao-numero-' + sectionId);
      if (nameInput) nameInput.value = '';
      if (numInput) numInput.value = '';
    }
  }

  function observeVariantChanges() {
    // Re-check on URL changes (variant switching)
    let lastUrl = location.href;
    const observer = new MutationObserver(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        setTimeout(init, 100);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also re-init after a short delay (handles slow-loading variant pickers)
  setTimeout(init, 500);
  setTimeout(init, 1500);
})();
